import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Services from "./pages/Services";
import TermsAndConditions from "./pages/TermsAndConditions"; // ✅ Add this
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ReturnPolicy from "./pages/ReturnPolicy";


function App() {
  return (
    <>
      <Header />
      <Routes>
        {/* ✅ Default Home route */}
        <Route path="/" element={<Home />} />

        {/* ✅ Extra Home route */}
        <Route path="/home" element={<Home />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />

        {/* ✅ Terms & Conditions Page Route */}
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />


      </Routes>
      <Footer />
    </>
  );
}

export default App;
